import { useCallback, useMemo, useState } from 'react';
import { useForm } from 'src/components/Form';
import ModalDialog, { ModalCloseHandler } from 'src/components/ModalDialog';
import { SolutionAdlsSubscriptionItem } from '../../types';
import { getAdlsSubscriptionEditFormFields } from '../editAdlsSubscriptionFormFields';

type Props = {
  item?: SolutionAdlsSubscriptionItem;
  title: string;
  loading?: boolean;
  open: boolean;
  onClose: ModalCloseHandler;
  onSubmit: (values: any) => void;
  confirmBtnText?: string;
};

function SolutionAdlsSubscriptionEditModal({
  item,
  title,
  loading,
  open,
  onClose,
  onSubmit,
  confirmBtnText = 'Save',
}: Props) {
  const [filters, setFilters] = useState<any[]>(item?.adlsFilters ?? []);
  const handlePaste = () => {
    navigator.clipboard.readText().then((clipboardText) => {
      setValue('containerSaasURL', clipboardText.trim());
    });
  };

  const onChange = useCallback(
    ({ adlsFilters }: SolutionAdlsSubscriptionItem) => {
      setFilters(adlsFilters);
    },
    []
  );
  const fields = useMemo(
    () => getAdlsSubscriptionEditFormFields(filters, item, handlePaste),
    [filters]
  );

  const [form, handleSubmit, setValue] = useForm({
    visibleValuesOnly: true,
    values: item,
    fields,
    onChange,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title={title}
      confirmBtnText={confirmBtnText}
      onClose={onClose}
      onConfirm={handleSubmit}
      loading={loading}
      fullWidth
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionAdlsSubscriptionEditModal;
